export default __webpack_public_path__ + "windwalker-logo-h-w.svg?f988bda5b988f388004860f38a7594e0";